import type { SensorMode, RfBoostSwitch, KeyScanRate } from '@rapoo/device-sdk'

/**
 * l15_多合一_3398_机械微动_机械编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率 该条件无按键扫描率 default: 3
 */
export function getBatteryLife_l15_pt0_3398_kt0_rt0_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate = 3,
): string {
  let batteryLife = '100'
  //125
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '990-1010'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '930-950'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '950-970'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '900-920'
  }
  //250
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '940-960'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '805-825'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '895-915'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '765-785'
  }
  //500
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '890-910'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '745-765'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '860-880'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '730-750'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '800-820'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '700-720'
  }
  //1000
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '750-770'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '595-615'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '700-720'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '570-590'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '170-190'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '165-185'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '100-110'
  }
  //2000
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '540-560'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '370-390'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '130-150'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '95-105'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-150'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '115-125'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '135-145'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '115-125'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '70-80'
  }
  return batteryLife + 'h'
}

/**
 * l15_1T1R_3398_机械微动_机械编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率 该条件无按键扫描率 default: 3
 */
export function getBatteryLife_l15_pt1_3398_kt0_rt0_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate = 3,
): string {
  let batteryLife = '100'
  //125
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '980-1000'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '910-930'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '950-970'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '880-900'
  }
  //250
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '920-940'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '790-810'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '890-910'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '730-750'
  }
  //500
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '810-830'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '625-645'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '780-800'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '610-630'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '610-630'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '570-590'
  }
  //1000
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '640-660'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '470-490'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '590-610'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '440-460'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '100-110'
  }
  //2000
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '420-440'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '285-305'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '150-160'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '130-140'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '145-155'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '125-135'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '125-135'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '120-130'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '80-90'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '50-60'
  }
  return batteryLife + 'h'
}

/**
 * l15_多合一_3950_光微动_机械编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率
 */
export function getBatteryLife_l15_pt0_3950_kt1_rt0_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate,
): string {
  let batteryLife = '100'
  //125
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '990-1010'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '820-840'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '630-650'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '420-440'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '930-950'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '760-780'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '595-615'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '410-430'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '950-970'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '790-810'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '610-630'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '415-435'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '900-920'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '730-750'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '580-600'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '405-425'
  }
  //250
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '940-960'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '750-770'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '590-610'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '400-420'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '805-825'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '655-675'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '540-560'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '390-410'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '895-915'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '730-750'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '580-600'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '395-415'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '765-785'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '640-660'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '525-545'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '380-400'
  }
  //500
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '890-910'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '720-740'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '575-595'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '390-410'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '745-765'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '630-650'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '510-530'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '370-390'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '860-880'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '710-730'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '560-580'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '385-405'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '730-750'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '615-635'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '500-520'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '355-375'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '800-820'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '670-690'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '525-545'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '370-390'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '700-720'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '580-600'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '460-480'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '345-365'
  }
  //1000
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '750-770'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '650-670'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '510-530'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '360-380'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '595-615'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '545-565'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '440-460'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '330-350'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '700-720'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '600-620'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '490-510'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '350-370'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '570-590'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '515-535'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '400-420'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '310-330'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '170-190'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '165-185'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '115-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '110-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  //2000
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '540-560'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '490-510'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '400-420'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '305-325'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '370-390'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '355-375'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '310-330'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '260-280'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '130-150'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '115-125'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '115-135'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '130-150'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '110-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '105-115'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '95-105'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-100'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-150'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '135-145'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '130-140'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '115-125'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '115-125'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '115-125'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '135-145'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '130-140'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '125-135'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '110-120'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '110-120'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '85-95'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '115-125'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '110-120'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '105-115'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '100-110'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '105-115'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  return batteryLife + 'h'
}

/**
 * l15_1T1R_3950_光微动_机械编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率
 */
export function getBatteryLife_l15_pt1_3950_kt1_rt0_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate,
): string {
  let batteryLife = '100'
  //125
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '980-1000'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '820-840'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '630-650'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '420-440'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '910-930'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '745-765'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '595-615'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '410-430'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '950-970'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '790-810'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '610-630'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '415-435'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '880-900'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '740-760'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '580-600'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '405-425'
  }
  //250
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '920-940'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '750-770'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '620-640'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '400-420'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '790-810'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '680-700'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '540-560'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '390-410'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '890-910'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '730-750'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '580-600'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '395-415'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '730-750'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '660-680'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '525-545'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '380-400'
  }
  //500
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '810-830'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '680-700'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '555-575'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '395-415'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '625-645'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '555-575'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '465-485'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '345-365'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '780-800'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '660-680'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '545-565'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '390-410'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '610-630'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '535-555'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '455-475'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '335-355'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '610-630'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '625-645'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '500-520'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '365-385'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '570-590'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '510-530'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '425-445'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '330-350'
  }
  //1000
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '640-660'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '560-580'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '470-490'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '350-370'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '470-490'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '420-440'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '405-425'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '290-310'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '590-610'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '520-540'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '435-455'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '330-350'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '440-460'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '400-420'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '355-375'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '280-300'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '115-135'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  //2000
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '420-440'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '390-410'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '340-360'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '275-295'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '285-305'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '270-290'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '245-265'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '210-230'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '145-155'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '135-145'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '130-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '130-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '120-130'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '115-125'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '110-120'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '145-155'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-150'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '130-140'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '120-130'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '125-135'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '115-125'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-120'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '105-115'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '105-115'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '95-105'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-100'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '125-135'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '120-130'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '115-125'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-115'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '85-95'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '120-130'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '115-125'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-120'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '85-95'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '50-60'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '50-60'
  }
  return batteryLife + 'h'
}

/**
 * l15_多合一_3950_机械微动_机械编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率
 */
export function getBatteryLife_l15_pt0_3950_kt0_rt0_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate,
): string {
  let batteryLife = '100'
  //125
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '990-1010'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '820-840'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '630-650'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '420-440'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '930-950'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '760-780'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '595-615'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '410-430'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '950-970'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '790-810'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '610-630'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '415-435'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '900-920'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '730-750'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '580-600'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '405-425'
  }
  //250
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '940-960'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '750-770'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '590-610'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '400-420'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '805-825'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '655-675'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '540-560'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '390-410'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '895-915'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '730-750'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '580-600'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '395-415'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '765-785'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '640-660'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '525-545'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '380-400'
  }
  //500
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '890-910'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '720-740'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '575-595'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '390-410'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '745-765'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '630-650'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '510-530'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '370-390'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '860-880'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '710-730'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '560-580'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '385-405'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '730-750'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '615-635'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '500-520'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '355-375'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '800-820'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '670-690'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '525-545'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '370-390'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '700-720'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '580-600'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '460-480'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '345-365'
  }
  //1000
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '750-770'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '650-670'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '510-530'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '360-380'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '595-615'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '545-565'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '440-460'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '330-350'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '700-720'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '600-620'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '490-510'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '350-370'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '570-590'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '515-535'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '400-420'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '310-330'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '170-190'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '165-185'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '115-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '110-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  //2000
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '540-560'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '490-510'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '400-420'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '305-325'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '370-390'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '355-375'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '310-330'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '260-280'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '130-150'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '115-125'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '115-135'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '130-150'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '110-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '105-115'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '95-105'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-100'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-150'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '135-145'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '130-140'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '115-125'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '115-125'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '115-125'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '135-145'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '130-140'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '125-135'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '110-120'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '110-120'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '85-95'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '115-125'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '110-120'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '105-115'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '100-110'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '105-115'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  return batteryLife + 'h'
}

/**
 * l15_1T1R_3950_机械微动_机械编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率
 */
export function getBatteryLife_l15_pt1_3950_kt0_rt0_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate,
): string {
  let batteryLife = '100'
  //125
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '980-1000'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '820-840'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '630-650'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '420-440'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '910-930'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '745-765'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '595-615'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '410-430'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '950-970'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '790-810'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '610-630'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '415-435'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '880-900'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '740-760'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '580-600'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '405-425'
  }
  //250
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '920-940'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '750-770'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '620-640'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '400-420'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '790-810'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '680-700'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '540-560'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '390-410'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '890-910'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '730-750'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '580-600'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '395-415'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '730-750'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '660-680'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '525-545'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '380-400'
  }
  //500
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '810-830'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '680-700'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '555-575'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '395-415'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '625-645'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '555-575'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '465-485'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '345-365'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '780-800'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '660-680'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '545-565'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '390-410'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '610-630'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '535-555'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '455-475'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '335-355'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '610-630'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '625-645'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '500-520'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '365-385'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '570-590'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '510-530'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '425-445'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '330-350'
  }
  //1000
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '640-660'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '560-580'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '470-490'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '350-370'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '470-490'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '420-440'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '405-425'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '290-310'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '590-610'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '520-540'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '435-455'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '330-350'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '440-460'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '400-420'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '355-375'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '280-300'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '115-135'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  //2000
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '420-440'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '390-410'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '340-360'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '275-295'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '285-305'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '270-290'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '245-265'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '210-230'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '145-155'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '135-145'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '130-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '130-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '120-130'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '115-125'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '110-120'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '145-155'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-150'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '130-140'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '120-130'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '125-135'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '115-125'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-120'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '105-115'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '105-115'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '95-105'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-100'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '125-135'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '120-130'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '115-125'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-115'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '85-95'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '120-130'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '115-125'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-120'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '85-95'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '50-60'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '50-60'
  }
  return batteryLife + 'h'
}

/**
 * l15_多合一_3955_光微动_光编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率
 */
export function getBatteryLife_l15_pt0_3955_kt1_rt1_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate,
): string {
  let batteryLife = '100'
  //125
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '990-1010'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '820-840'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '630-650'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '420-440'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '930-950'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '760-780'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '595-615'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '410-430'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '950-970'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '790-810'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '610-630'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '415-435'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '900-920'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '730-750'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '580-600'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '405-425'
  }
  //250
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '940-960'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '750-770'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '590-610'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '400-420'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '805-825'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '655-675'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '540-560'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '390-410'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '895-915'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '730-750'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '580-600'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '395-415'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '765-785'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '640-660'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '525-545'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '380-400'
  }
  //500
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '890-910'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '720-740'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '575-595'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '390-410'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '745-765'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '630-650'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '510-530'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '370-390'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '860-880'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '710-730'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '560-580'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '385-405'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '730-750'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '615-635'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '500-520'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '355-375'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '800-820'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '670-690'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '525-545'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '370-390'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '700-720'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '580-600'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '460-480'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '345-365'
  }
  //1000
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '750-770'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '650-670'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '510-530'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '360-380'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '595-615'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '545-565'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '440-460'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '330-350'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '700-720'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '600-620'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '490-510'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '350-370'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '570-590'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '515-535'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '400-420'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '310-330'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '170-190'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '165-185'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '115-125'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '110-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  //2000
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '540-560'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '490-510'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '400-420'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '305-325'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '370-390'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '355-375'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '310-330'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '260-280'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '130-150'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '115-125'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '150-170'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '115-135'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '130-150'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '125-145'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '110-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '105-115'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '95-105'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-100'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '140-150'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '135-145'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '130-140'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '115-125'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '115-125'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '115-125'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '135-145'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '130-140'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '125-135'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '110-120'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '110-120'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '85-95'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '115-125'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '110-120'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '105-115'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '100-110'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '105-115'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  return batteryLife + 'h'
}

/**
 * l15_1T1R_3955_光微动_光编码器_800mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率
 */
export function getBatteryLife_l15_pt1_3955_kt1_rt1_800(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate,
): string {
  let batteryLife = '100'
  //125
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '980-1000'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '820-840'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '630-650'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '420-440'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '910-930'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '745-765'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '595-615'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '410-430'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '950-970'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '790-810'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '610-630'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '415-435'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '880-900'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '740-760'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '580-600'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '405-425'
  }
  //250
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '920-940'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '750-770'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '620-640'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '400-420'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '790-810'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '680-700'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '540-560'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '390-410'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '890-910'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '730-750'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '580-600'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '395-415'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '730-750'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '660-680'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '525-545'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '380-400'
  }
  //500
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '810-830'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '680-700'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '555-575'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '395-415'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '625-645'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '555-575'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '465-485'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '345-365'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '780-800'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '660-680'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '545-565'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '390-410'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '610-630'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '535-555'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '455-475'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '335-355'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '610-630'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '625-645'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '500-520'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '365-385'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '570-590'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '510-530'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '425-445'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '330-350'
  }
  //1000
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '640-660'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '560-580'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '470-490'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '350-370'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '470-490'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '420-440'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '405-425'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '290-310'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '590-610'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '520-540'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '435-455'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '330-350'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '440-460'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '400-420'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '355-375'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '280-300'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '160-180'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '120-140'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '135-155'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '115-135'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '110-120'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '105-115'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  //2000
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '420-440'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '390-410'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '340-360'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '275-295'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '285-305'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '270-290'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '245-265'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '210-230'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '145-155'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '135-145'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '130-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '130-140'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '120-130'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '115-125'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '110-120'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '145-155'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '140-150'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '130-140'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '120-130'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '125-135'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '115-125'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-120'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '105-115'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '105-115'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '100-110'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-105'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '95-105'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-100'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '125-135'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '120-130'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '115-125'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '105-115'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '85-95'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '120-130'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '115-125'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '110-120'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '100-110'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '95-105'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '90-100'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '85-95'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '80-90'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '75-85'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '70-80'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '90-100'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '85-95'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '80-90'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '60-70'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '75-85'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '70-80'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '55-65'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '50-60'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '50-60'
  }
  return batteryLife + 'h'
}

/**
 * l15_多合一_3950_光微动_光编码器_300mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率
 */
export function getBatteryLife_l15_pt0_3950_kt1_rt1_300(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate,
): string {
  let batteryLife = '100'
  //125
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '320-340'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '245-265'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '165-185'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '310-330'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '240-260'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '165-185'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '305-325'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '240-260'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '160-180'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '290-310'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '230-250'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '160-180'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  //250
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '300-320'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '230-250'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '160-180'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '275-295'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '220-240'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '155-175'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '290-310'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '230-250'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '155-175'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '265-285'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '215-225'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '150-170'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  //500
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '290-310'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '225-245'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '155-175'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '265-285'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '215-225'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '150-170'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '290-310'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '220-240'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '155-175'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '260-280'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '210-230'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '150-170'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '260-280'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '205-225'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '240-260'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '195-215'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  //1000
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '255-275'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '200-220'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '215-235'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '180-200'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '85-105'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '240-260'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '190-210'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '200-220'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '170-190'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '60-70'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '50-60'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '50-60'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '60-70'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '50-60'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '45-55'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '50-60'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  //2000
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '190-210'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '160-180'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '120-140'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '145-165'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '130-150'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '70-90'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '50-70'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '55-65'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '50-60'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '55-65'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '50-60'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '50-60'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '40-50'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '40-50'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '40-50'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '40-50'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '50-60'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '40-50'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '40-50'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '40-50'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '40-50'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '40-50'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '30-40'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '30-35'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '30-40'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '40-50'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '30-40'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '30-40'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '20-30'
  }
  return batteryLife + 'h'
}

/**
 * l15_1T1R_3950_光微动_光编码器_300mAh
 * @param id 回报率
 * @param modeID 传感器模式
 * @param rfStrengthSwitch 射频策略
 * @param keyScanRate 按键扫描率
 */
export function getBatteryLife_l15_pt1_3950_kt1_rt1_300(
  id: number,
  modeID: SensorMode,
  rfStrengthSwitch: RfBoostSwitch,
  keyScanRate: KeyScanRate,
): string {
  let batteryLife = '100'
  //125
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '315-335'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '240-260'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '165-185'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '305-325'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '235-255'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '165-185'
  }
  if (id === 0 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '310-330'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '230-250'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '160-180'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '290-310'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '230-250'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '160-180'
  }
  if (id === 0 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  //250
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '300-320'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '225-245'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '160-180'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '100-120'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '275-295'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '220-240'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '155-175'
  }
  if (id === 1 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '290-310'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '220-240'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '155-175'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '265-285'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '215-235'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '155-175'
  }
  if (id === 1 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  //500
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '290-310'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '225-245'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '155-175'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '235-255'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '190-210'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 2 && modeID === 0 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '260-280'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '210-230'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '145-165'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '95-115'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '225-245'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '190-210'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 2 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '245-265'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '190-210'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '140-160'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '90-110'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '210-230'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '175-195'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '130-150'
  }
  if (id === 2 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '85-105'
  }
  //1000
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '220-240'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '180-200'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '130-150'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '85-105'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '170-190'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '150-170'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '115-135'
  }
  if (id === 3 && modeID === 1 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '80-100'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '205-225'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '170-190'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '125-145'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '85-105'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '165-185'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '140-160'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '110-130'
  }
  if (id === 3 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '75-95'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '50-60'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 3 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '50-60'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '55-65'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 3 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '40-50'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '35-45'
  }
  if (id === 3 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  //2000
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '155-175'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '130-150'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '105-125'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '70-90'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '110-130'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '100-120'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '85-95'
  }
  if (id === 4 && modeID === 2 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '65-75'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '55-65'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '40-50'
  }
  if (id === 4 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '55-65'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '50-60'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '40-50'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '45-55'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '40-50'
  }
  if (id === 4 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 4 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  //4000
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '45-55'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '45-55'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '40-50'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '45-55'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '40-50'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '35-45'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '30-40'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '25-35'
  }
  if (id === 5 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  //8000
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '30-40'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '30-40'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '30-40'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 3 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '30-40'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '30-40'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 4 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 3) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 4) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 5) {
    batteryLife = '25-35'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 0 && keyScanRate === 6) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 3) {
    batteryLife = '20-30'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 4) {
    batteryLife = '15-25'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 5) {
    batteryLife = '15-25'
  }
  if (id === 6 && modeID === 5 && rfStrengthSwitch === 1 && keyScanRate === 6) {
    batteryLife = '15-25'
  }
  return batteryLife + 'h'
}
